export const HOME = '/';
export const SIGN_IN = '/signin';
export const WIDGETS = '/widgets';
export const CREATE_WIDGET= '/create-widget';
export const EDIT_WIDGET= '/edit-widget/:id';